import { IDevice } from "@formant/core/model/IDevice";

import { audioDevicesForDevices } from "../component/Observe/utils/audioDevicesForDevices";

export function audioPathsMapForDevices(devices: IDevice[] | undefined) {
    return audioDevicesForDevices(devices).reduce<{ [id: string]: string }>(
        (acc, audioDevice) => ({
            ...acc,
            ...(audioDevice.name === audioDevice.id
                ? { [audioDevice.name]: audioDevice.id }
                : {
                      [`${audioDevice.name} - ${audioDevice.id}`]:
                          audioDevice.id,
                  }),
        }),
        {},
    );
}
